import { formatDateForApi } from '@/shared/lib';

export const dateToString = (date: Date | null | undefined): string | undefined => {
  if (!date) return undefined;
  return formatDateForApi(date) ?? undefined;
};
